export default __webpack_public_path__ + "static/media/Aditya.4c6798d5.jpg";